import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
// import FeaturedPlayListIcon from "@mui/icons-material/FeaturedPlayList";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import SettingsIcon from "@mui/icons-material/Settings";
import React, { useContext, useMemo } from "react";
import { useTextDomainContext } from "@/app/providers";
import { useHasPermission } from "@/hooks";
import { permissionsCompaniesReadonly } from "@/utils";

interface MenuItemTenantProps<TRow extends object = Record<string, unknown>> {
  row?: TRow;
  menuFor?: string;
  handleClose: () => void;
  menuClick: (_action: string, _row?: TRow) => void;
  showItems?: Record<string, boolean | undefined>;
}

const feature = "common";

export const MenuItemTenant = <TRow extends object = Record<string, unknown>>(
  props: MenuItemTenantProps<TRow>,
): React.ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { allow: allowCompaniesReadonly } = useHasPermission(
    permissionsCompaniesReadonly,
    feature,
  );

  //#region useMemo

  const menuFor = useMemo(() => {
    return props.menuFor ?? "";
  }, [props.menuFor]);

  //#endregion useMemo

  //#region Handlers

  const handleClose = () => {
    props.handleClose();
  };

  const handleEditAction = () => {
    props.menuClick(`${menuFor}-edit`, props.row);
    handleClose();
  };

  const handleUsersAction = () => {
    props.menuClick(`${menuFor}-users`, props.row);
    handleClose();
  };

  const handleCompaniesAction = () => {
    props.menuClick(`${menuFor}-companies`, props.row);
    handleClose();
  };

  const handleSettingsAction = () => {
    props.menuClick(`${menuFor}-settings`, props.row);
    handleClose();
  };

  // const handleFeaturesAction = () => {
  //   props.menuClick(`${menuFor}-features`, props.row);
  //   handleClose();
  // };

  const handleDeleteAction = () => {
    props.menuClick(`${menuFor}-delete`, props.row);
    handleClose();
  };

  //#endregion Handlers

  return (
    <>
      {props?.showItems?.showEdit && (
        <MenuItem onClick={handleEditAction}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Edit")} />
        </MenuItem>
      )}

      {props?.showItems?.showUsers && (
        <MenuItem onClick={handleUsersAction}>
          <ListItemIcon>
            <PeopleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Users")} />
        </MenuItem>
      )}

      {props?.showItems?.showCompanies && allowCompaniesReadonly && (
        <MenuItem onClick={handleCompaniesAction}>
          <ListItemIcon>
            <BusinessIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Companies")} />
        </MenuItem>
      )}

      {props?.showItems?.showSettings && (
        <MenuItem onClick={handleSettingsAction}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Settings")} />
        </MenuItem>
      )}

      {/* {props?.showItems?.showFeatures && (
        <MenuItem onClick={handleFeaturesAction}>
          <ListItemIcon>
            <FeaturedPlayListIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Features")} />
        </MenuItem>
      )} */}

      {props?.showItems?.showDelete && (
        <MenuItem onClick={handleDeleteAction}>
          <ListItemIcon>
            <DeleteIcon color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={gettext("Delete")}
            slotProps={{
              primary: {
                color: "error",
              },
            }}
          />
        </MenuItem>
      )}
    </>
  );
};
